<template>
    <div class="animated fadeIn">
        <b-card>

            <div class="btn-group pull-right mb-2">
                <button class="btn btn-success btn-sm" @click="onAddForm()">Добавить форму</button>
            </div>
            <v-server-table :url="apiurl('orderform/table')"  :columns="columns" :options="options" :theme="theme" id="orderformTable" ref="orderformTable" >
                <a slot="cmd_disable" slot-scope="props" href="#" @click.prevent="onDisable(props.row, !!props.row.disabled_at)"  >
                    <i class="cui-lightbulb text-secondary fa-lg" v-if="!!props.row.disabled_at"></i>
                    <i class="cui-lightbulb text-warning fa-lg" v-if="!props.row.disabled_at"></i>
                </a>
                <a slot="cmd_code" slot-scope="props" href="#" @click.prevent="onCode(props.row)"><i class="icon-puzzle fa-lg text-primary"></i></a>
                <a slot="cmd_edit" slot-scope="props" href="#" @click.prevent="onEdit(props.row)"><i class="fa fa-edit fa-lg text-primary"></i></a>
                <a slot="cmd_delete" slot-scope="props" href="#" @click.prevent="onDelete(props.row)"><i class="fa fa-trash fa-lg text-danger"></i></a>
            </v-server-table>
        </b-card>
        <form-code-dialog v-model="form_id_code_dialog" v-if="form_id_code_dialog"></form-code-dialog>
        <form-edit-dialog v-model="form_id_edit_dialog" v-if="form_id_edit_dialog" @change="onChanged"></form-edit-dialog>

        <b-modal :title="'Удаление формы #'+ form_id_delete" class="modal-danger" centered  v-model="showDeleteModal" @ok="continueDelete()" ok-variant="danger">
            Вы собираетесь удалить форму.
            <template slot="modal-footer" slot-scope="{ ok, cancel, hide }">
                <b>Ваше решение:</b>
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Отказаться
                </b-button>
                <b-button size="sm" variant="danger" @click="ok()">
                    Продолжить удаление
                </b-button>
            </template>
        </b-modal>


    </div>
</template>

<script>
    import { functions } from '@/functions.js';
    import { orderform_functions } from '@/functions/orderform.js';

    import {CONSTANTS} from '@/constants';
    import FormEditDialog from '@/dialogs/FormEditDialog';
    import FormCodeDialog from '@/dialogs/FormCodeDialog';

    export default {
        name: 'NsbWebmasterWebform',
        mixins: [functions, orderform_functions],
        components: { FormEditDialog, FormCodeDialog },
        data: function () {
            return {
                columns: [ 'id', 'title', 'company.title', 'website', 'hotel.title', 'cmd_disable', 'cmd_edit', 'cmd_code', 'cmd_delete'],
                labelIcon: {
                    dataOn: '\u2713',
                    dataOff: '\u2715'
                },
                options: {
                    headings: {
                        id: '#',
                        title: 'наименование формы',
                        website: 'веб-сайт',
                        'company.title': 'владелец формы',
                        'hotel.title': 'объект размещения',
                        cmd_edit: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование формы"></i>
                        )},
                        cmd_disable: function(h) { return (
                            <i class="cui-lightbulb fa-lg" title="включение/отключение формы"></i>
                        ) },
                        cmd_code: function(h) { return (
                            <i class="icon-puzzle fa-lg" title="код для вставки на сайт"></i>
                        ) },
                        cmd_delete: function(h) { return (
                            <i class="fa fa-trash fa-lg" title="удление формы"></i>
                        ) },
                    },
                    sortable: ['id'],
                    filterable: ['id', 'website', 'title'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    templates: { },
                    customFilters: [ ],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    saveState: true,
                },
                theme: 'bootstrap4',
                template: 'default',

                form_id_code_dialog:0,
                form_id_edit_dialog:0,
                form_id_delete: 0,
                showDeleteModal:false,
            }
        },
        methods: {
            onDisable: function(orderform, state) {
                if (state) {
                    this.enableOrderForm(orderform.id, function() {
                        orderform.disabled_at = false;
                    })
                }
                else {
                    this.disableOrderForm(orderform.id, function() {
                        orderform.disabled_at = true;
                    })
                }
            },

            onCode: function(orderform) {
                this.form_id_code_dialog = orderform.id;
            },

            onEdit: function(orderform) {
                this.form_id_edit_dialog = orderform.id;
            },

            onDelete: function(form) {
                this.showDeleteModal = true;
                this.form_id_delete = form.id;
            },

            continueDelete: function() {
                this.deleteOrderForm(this.form_id_delete, function (self) {
                    self.$refs.orderformTable.refresh();
                }, this);
            },

            onAddForm: function() {
                this.createOrderForm(function (self, param) {
                    console.log('createForm param ', param);
                    self.$refs.orderformTable.refresh();
                }, this);
            },

            onChanged: function () {
                this.$refs.orderformTable.refresh();
            }
        },
        computed: { },
        created: function() { }
    }
</script>
